import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useLocation } from "react-router-dom"; 
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link } from "react-router-dom";
import Dynamicmeta from './Dynamicmeta';
import GoogleTranslateDropdown from './GoogleTranslateDropdown';

const Header = () => {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [tooldata, setTooldata] = useState([]);
     const [metaData, setMetaData] = useState({
        title: "Default Title",
        description: "Default description",
        keywords: "default, keywords",
        favicon: "/images/favicon-default.png"
    });

    // Fetch Navbar Data
    const dataFetch = async () => {
        try {
            let response = await fetch("https://codeinputs.com/reactapi/api/codeinputs/navbar", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({ url: location.pathname }),
            });
            const result = await response.json();
            setData(result.html);
            localStorage.setItem("dropdown", JSON.stringify(result.html));
        } catch (error) {
            console.error("Error fetching navbar data:", error);
        }
    };

    // Fetch Tools Navtoolbar Data
    const dataFetchs = async () => {
        try {
            let responses = await fetch("https://codeinputs.com/reactapi/api/codeinputs/toolnavbar", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({ url: location.pathname }),
            });
            const results = await responses.json();
            setTooldata(results.html);
            localStorage.setItem("tooldropdown", JSON.stringify(results.html));
        } catch (error) {
            console.error("Error fetching navbar data:", error);
        }
    };


    // Fetch Data When Path Changes
    useEffect(() => {
            dataFetch();
            dataFetchs();
    }, [location.pathname]); 


    return (
        <>
            <Dynamicmeta/>
            <Navbar expand="lg" className="navbar top-nav-collapse">
                <Container>
                    <Navbar.Brand href="/">
                        <img src="/graphics/images/logo_new_resize.webp" loading="lazy" alt="Logo" width="100" height="33" className="d-inline-block align-top" />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />

                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Link className={`nav-link ${location.pathname === "/" ? "mainactive" : "mymenu"}`} to="/">Home</Link>
                            <Link className={`nav-link ${location.pathname === "/about" ? "mainactive" : "mymenu"}`} to="/about">About Us</Link>

                            <NavDropdown className="mymenu mydropdown" title="Blog" id="basic-nav-dropdown">
                                {data.length > 0 ? (
                                    data.map((item, index) => (
                                        <NavDropdown.Item key={index} className={`dropactive ${location.pathname === `/${item.route}` ? "active" : ""}`}>
                                            <Link className={`${location.pathname === `/${item.route}` ? "active" : ""}`} to={`/${item.route}`}>{item.name || "Untitled"}</Link>
                                        </NavDropdown.Item>
                                    ))
                                ) : (
                                    <NavDropdown.Item disabled>No blog items</NavDropdown.Item>
                                )}
                            </NavDropdown>

                            <NavDropdown className="mymenu mydropdown" title="Tools" id="basic-nav-dropdown">
                                {tooldata.length > 0 ? (
                                    tooldata.map((item, index) => (
                                        <NavDropdown.Item key={index} className={`dropactive ${location.pathname === `/${item.route}` ? "active" : ""}`}>
                                            <Link className={`${location.pathname === `/${item.route}` ? "active" : ""}`} to={`/${item.route}`}>{item.name || "Untitled"}</Link>
                                        </NavDropdown.Item>
                                    ))
                                ) : (
                                    <NavDropdown.Item disabled>No blog items</NavDropdown.Item>
                                )}
                            </NavDropdown>

                            <Link className={`nav-link ${location.pathname === "/contactus.html" ? "mainactive" : "mymenu"}`} to="/contactus.html">Contact Us</Link>
                            <Link><GoogleTranslateDropdown/></Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default Header;
